import { useState } from "react";
import styled, { keyframes } from "styled-components";

// Logo
import Logo from "../../../assets/images/logo/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AccountCircle,
  CloseOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  LocalMallOutlined,
  FavoriteBorderOutlined,
} from "@mui/icons-material";
import { Badge } from "@mui/material";
import { colors } from "../../../data";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

// css

const MainNav = styled.nav`
  padding: 1rem;
  position: sticky;
  top: 0;
  background-color: #f8ecd7;
  padding: 1rem 0;
  z-index: 100;
  @media only screen and (max-width: 949px) {
  }
`;

// Pc Navbar

const PcNav = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: 0.6fr 4fr 1fr;
  @media only screen and (max-width: 949px) {
    display: none;
  }
  a {
    span {
      svg {
        transform: scale(1.8);
      }
    }
  }
`;

const LogoDiv = styled.div`
  background: url(${(props) => props.logo});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 3.7rem;
  width: 260px;
  @media only screen and (max-width: 949px) {
    width: 60%;
    height: 4.1rem;
  }
`;

const PageLinksDiv = styled.div`
  height: 3.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  text-transform: uppercase;
  a {
    text-decoration: none;
    transition: all 0.2s;
    backface-visibility: hidden;
    position: relative;
    font-size: 1.5rem;
    letter-spacing: 0.12rem;
    font-weight: 500;
    &:hover {
      color: ${colors.mainColor};
    }
  }
`;

const UserControlsDiv = styled.div`
  height: 3.7rem;
  display: flex;
  justify-content: end;
  gap: 1.8rem;
  align-items: center;
  font-size: 1.4rem;
  padding-right: 2rem;
  a {
    text-decoration: none;
    transition: all 0.2s;
    backface-visibility: hidden;
    color: black;
    letter-spacing: 0.09rem;
    &:hover {
      color: ${colors.mainColor};
      transform: scale(1.15) translateZ(0);
    }
    svg {
      transform: scale(1.2);
    }
  }
`;

// Mobile Navbar

const MobileNav = styled.div`
  position: relative;
  overflow: hidden;
  padding-right: 1rem;
  padding-top: 0.2rem;
  span {
    svg {
      color: ${colors.mainColor};
      transform: scale(1.5);
    }
    span {
      background-color: ${colors.secondaryColor};
    }
  }
  @media only screen and (max-width: 949px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      border: none;
      outline: none;
      background-color: transparent;

      div {
        width: 30px;
        height: 2.4px;
        background-color: black;
        margin: 4px 0;
      }
    }
  }

  /*  */

  @media only screen and (min-width: 950px) and (max-width: 2500px) {
    display: none;
  }
`;
const FadeUpAni = keyframes`
  0%{
    opacity: 0;
    transform: translateY(20px);
  }
  100%{
    opacity: 1;
    transform: translateY(0px);
  }
`;

const FadeAni = keyframes`
  0%{
    opacity: 0;
    display: none;
    transform: translateY(30px);

  }
  100%{
    opacity: 1;
    transform: translateY(0px);
  }

`;

const HiddenMobileDiv = styled.div`
  text-transform: uppercase;
  background-color: #fdfbf3;
  padding: 2rem 2rem;
  width: 67%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 10;
  transition: all 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  transform: ${(props) =>
    props.status === "false" ? "translateX(-100%)" : "translateX(0)"};

  span {
    position: absolute;
    top: 0.2rem;
    color: #424242;
    right: 0.2rem;
    padding: 1rem 1.5rem;
    border-radius: 50%;
    transform: scale(1.3);
    animation: ${FadeAni} 1s;
    backface-visibility: hidden;
  }
  @media only screen and (min-width: 950px) and (max-width: 2500px) {
    display: none;
  }
  a {
    color: #393939;
    font-size: 1.5rem;
    letter-spacing: 0.1rem;
    padding: 1rem 0;
    animation: ${FadeAni} 1s;
    backface-visibility: hidden;
    text-decoration: none;
    border-bottom: 1px solid #dedede;
  }
  p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      border-left: 1px solid #dedede;
      width: 20%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

const HiddenNavLinksDiv = styled.div`
  display: flex;
  border-bottom: 1px solid #dedede;
  gap: 1rem;
  padding: 1rem 0;
  animation: ${FadeUpAni} 1s;
  animation-delay: 0.9s;
  letter-spacing: 0.09rem;
  svg {
    transform: scale(1.6);
    margin-top: 0.6rem;
  }
  p {
    display: flex;
    align-items: center;
    height: 100%;

    a {
      border: none;
      padding: 0;
      font-size: 1.2rem;
    }
  }
`;

const CollapsibleDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0.2rem;
  a {
    animation: ${FadeUpAni} 1s;
    border: none;
    text-transform: capitalize;
    font-weight: bold;
    font-size: 1.2rem;
  }
`;

const defaultSubCategories = [
  // Woman Top Wear
  { title: "Printed Suit", slug: "printed-suit", parentCategory: "Women Top Wear" },
  { title: "Jump Suit", slug: "jump-suit", parentCategory: "Women Top Wear" },
  { title: "Neck Stone Work Printed and Gather Jumpsuit", slug: "neck-stone-work-jumpsuit", parentCategory: "Women Top Wear" },
  { title: "Anarkali Suit Sets", slug: "anarkali-suit-sets", parentCategory: "Women Top Wear" },
  { title: "A Line Top with Dhoti Pant", slug: "a-line-top-dhoti-pant", parentCategory: "Women Top Wear" },
  { title: "Kurti with Palazzos", slug: "kurti-palazzos", parentCategory: "Women Top Wear" },
  { title: "Flared Kurti", slug: "flared-kurti", parentCategory: "Women Top Wear" },
  { title: "Co-Ord Set", slug: "co-ord-set", parentCategory: "Women Top Wear" },
  { title: "Straight Top", slug: "straight-top", parentCategory: "Women Top Wear" },
  { title: "Flared Dress", slug: "flared-dress", parentCategory: "Women Top Wear" },
  { title: "Dress Material", slug: "dress-material", parentCategory: "Women Top Wear" },
  { title: "Dupattas", slug: "dupattas", parentCategory: "Women Top Wear" },
  { title: "Saree", slug: "saree", parentCategory: "Women Top Wear" },

  // Handbags
  { title: "Wallets", slug: "wallets", parentCategory: "Handbags" },
  { title: "Totes & Top Handle", slug: "totes-top-handle", parentCategory: "Handbags" },
  { title: "Clutches", slug: "clutches", parentCategory: "Handbags" },
  { title: "Sling", slug: "sling", parentCategory: "Handbags" },

  // Footwear
  { title: "Slippers & Slides", slug: "slippers-slides", parentCategory: "Footwear" },
  { title: "Sandals", slug: "sandals", parentCategory: "Footwear" },
  { title: "Mojaris & Mules", slug: "mojaris-mules", parentCategory: "Footwear" },
  { title: "Loafers & Close Shoe", slug: "loafers-close-shoe", parentCategory: "Footwear" },
  { title: "Heels", slug: "heels", parentCategory: "Footwear" },
  { title: "Girls Footwears", slug: "girls-footwears", parentCategory: "Footwear" },

  // Silver Accessories
  { title: "Earing", slug: "earing", parentCategory: "Silver Accessories" },
  { title: "Necklaces", slug: "necklaces", parentCategory: "Silver Accessories" },
  { title: "Rings", slug: "rings", parentCategory: "Silver Accessories" },
  { title: "Bangles & Bracelets", slug: "bangles-bracelets", parentCategory: "Silver Accessories" },
  { title: "Addons", slug: "addons", parentCategory: "Silver Accessories" },
  { title: "Contemporary", slug: "contemporary", parentCategory: "Silver Accessories" },
  { title: "Festive", slug: "festive", parentCategory: "Silver Accessories" },
];

// Component
const Navbar = () => {
  const path = useLocation().pathname;
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const userId = useSelector((state) => state.userId);
  const cartTotalItems = useSelector((state) => (state.cartItems ?? []).length);
  const wishlistTotalItems = useSelector((state) => (state.wishlistItems ?? []).length);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [categories, setCategories] = useState(defaultSubCategories);
  const [arrowTopWear, setArrowTopWear] = useState(true);
  const [arrowHandbag, setArrowHandbag] = useState(true);
  const [arrowFootwear, setArrowFootwear] = useState(true);
  const [arrowEarring, setArrowEarring] = useState(true);
  const [mobileNav, setMobileNav] = useState(false);
  const [linksActive, setLinksActive] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}/category/all-category`
        );
        const data = await res.json();
        if (
          isMounted &&
          data &&
          Array.isArray(data.categories) &&
          data.categories.length > 0
        ) {
          setCategories(data.categories.filter((c) => c.status !== false));
        }
      } catch (err) {
        console.error("Error fetching categories in Navbar:", err);
      }
    };
    fetchCategories();
    return () => {
      isMounted = false;
    };
  }, []);

  const normalizeParent = (parent) => {
    if (!parent) return "Women Top Wear";
    const p = parent.toLowerCase().trim();
    if (p.includes("handbag") || p.includes("bag")) return "Handbags";
    if (p.includes("footwear") || p.includes("shoe")) return "Footwear";
    if (
      p.includes("silver") ||
      p.includes("accessor") ||
      p.includes("jewel")
    )
      return "Silver Accessories";
    if (p.includes("top") || p.includes("wear") || p.includes("women"))
      return "Women Top Wear";
    return parent;
  };

  const womenTopWearSubCats = categories.filter(
    (c) => normalizeParent(c.parentCategory) === "Women Top Wear"
  );
  const handbagsSubCats = categories.filter(
    (c) => normalizeParent(c.parentCategory) === "Handbags"
  );
  const footwearSubCats = categories.filter(
    (c) => normalizeParent(c.parentCategory) === "Footwear"
  );
  const silverSubCats = categories.filter(
    (c) => normalizeParent(c.parentCategory) === "Silver Accessories"
  );

  const isCategoryActive = (subCats) =>
    subCats.some((c) => path === `/product-category/${c.slug}`);

  const menuButtonHandler = () => {
    setMobileNav(!mobileNav);
    setArrowTopWear(true);
    setArrowHandbag(true);
    setArrowFootwear(true);
    setArrowEarring(true);
    setTimeout(() => {
      setLinksActive(!linksActive);
    }, 50);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, [path]);

  return (
    <MainNav>
      <HiddenMobileDiv status={mobileNav.toString()}>
        <span onClick={menuButtonHandler}>
          <CloseOutlined />
        </span>
        {!isLoggedIn && (
          <HiddenNavLinksDiv onClick={menuButtonHandler}>
            <>
              <AccountCircle />
              <p>
                <Link to="/login">log in</Link>
              </p>
            </>
          </HiddenNavLinksDiv>
        )}
        {linksActive && (
          <Link onClick={menuButtonHandler} to="/">
            Home
          </Link>
        )}
        {linksActive && (
          <Link
            onClick={menuButtonHandler}
            className={
              path === "/product-category/all-products"
                ? "activeLink"
                : "nonActiveLink"
            }
            to="/product-category/all-products"
          >
            Shop All
          </Link>
        )}
        {linksActive && (
          <>
            {/* Woman Top Wear */}
            <Link>
              <p
                onClick={() => {
                  setArrowTopWear(!arrowTopWear);
                }}
                type="button"
                className="para"
                data-toggle="collapse"
                data-target="#woman-topwear"
              >
                Woman Top Wear
                <i
                  onClick={(e) => {
                    const para = e.target.closest(".para");
                    if (para) para.click();
                  }}
                >
                  {arrowTopWear ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                </i>
              </p>

              <div id="woman-topwear" className="collapse">
                <CollapsibleDiv>
                  {womenTopWearSubCats.map((sub) => (
                    <Link
                      key={sub._id || sub.slug}
                      to={`/product-category/${sub.slug}`}
                      onClick={menuButtonHandler}
                    >
                      {sub.title}
                    </Link>
                  ))}
                </CollapsibleDiv>
              </div>
            </Link>

            {/* Handbags */}
            <Link>
              <p
                onClick={() => setArrowHandbag(!arrowHandbag)}
                type="button"
                className="para"
                data-toggle="collapse"
                data-target="#handbags"
              >
                Handbags
                <i
                  onClick={(e) => {
                    const para = e.target.closest(".para");
                    if (para) para.click();
                  }}
                >
                  {arrowHandbag ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                </i>
              </p>

              <div id="handbags" className="collapse">
                <CollapsibleDiv>
                  {handbagsSubCats.map((sub) => (
                    <Link
                      key={sub._id || sub.slug}
                      to={`/product-category/${sub.slug}`}
                      onClick={menuButtonHandler}
                    >
                      {sub.title}
                    </Link>
                  ))}
                </CollapsibleDiv>
              </div>
            </Link>

            {/* Footwear */}
            <Link>
              <p
                onClick={() => setArrowFootwear(!arrowFootwear)}
                type="button"
                className="para"
                data-toggle="collapse"
                data-target="#footwear"
              >
                Footwear
                <i
                  onClick={(e) => {
                    const para = e.target.closest(".para");
                    if (para) para.click();
                  }}
                >
                  {arrowFootwear ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                </i>
              </p>

              <div id="footwear" className="collapse">
                <CollapsibleDiv>
                  {footwearSubCats.map((sub) => (
                    <Link
                      key={sub._id || sub.slug}
                      to={`/product-category/${sub.slug}`}
                      onClick={menuButtonHandler}
                    >
                      {sub.title}
                    </Link>
                  ))}
                </CollapsibleDiv>
              </div>
            </Link>

            {/* Silver Accessories */}
            <Link>
              <p
                onClick={() => setArrowEarring(!arrowEarring)}
                type="button"
                className="para"
                data-toggle="collapse"
                data-target="#earring"
              >
                Silver Accessories
                <i
                  onClick={(e) => {
                    const para = e.target.closest(".para");
                    if (para) para.click();
                  }}
                >
                  {arrowEarring ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                </i>
              </p>

              <div id="earring" className="collapse">
                <CollapsibleDiv>
                  {silverSubCats.map((sub) => (
                    <Link
                      key={sub._id || sub.slug}
                      to={`/product-category/${sub.slug}`}
                      onClick={menuButtonHandler}
                    >
                      {sub.title}
                    </Link>
                  ))}
                </CollapsibleDiv>
              </div>
            </Link>
          </>
        )}

        {linksActive && isLoggedIn && (
          <Link onClick={menuButtonHandler} to={`/account/${userId}/orders`}>
            Orders
          </Link>
        )}
        {linksActive && isLoggedIn && (
          <Link onClick={menuButtonHandler} to={`/account/${userId}`}>
            Account
          </Link>
        )}
        {linksActive && isLoggedIn && (
          <Link
            onClick={() => {
              dispatch({ type: "logout" });
              menuButtonHandler();
              navigate("/");
            }}
            to="/"
          >
            Log out
          </Link>
        )}
      </HiddenMobileDiv>
      <PcNav data-aos="fade-down">
        <LogoDiv logo={Logo}>
          <Link to="/"></Link>
        </LogoDiv>
        <PageLinksDiv className="dc-menu">
          <Link
            className={path === "/" ? "activeLink" : "nonActiveLink"}
            to="/"
          >
            Home
          </Link>
          <Link
            className={
              path === "/product-category/all-products"
                ? "activeLink"
                : "nonActiveLink"
            }
            to="/product-category/all-products"
          >
            Shop All
          </Link>
          <Link
            className={
              isCategoryActive(womenTopWearSubCats)
                ? "activeLink"
                : "nonActiveLink"
            }
            to="/"
            onClick={(e) => e.preventDefault()}
          >
            Women Top Wear <KeyboardArrowDown />
            <ul className="dropdown-menu">
              {womenTopWearSubCats.map((sub) => (
                <li key={sub._id || sub.slug}>
                  <Link to={`/product-category/${sub.slug}`}>{sub.title}</Link>
                </li>
              ))}
            </ul>
          </Link>
          <Link
            className={
              isCategoryActive(handbagsSubCats)
                ? "activeLink"
                : "nonActiveLink"
            }
            to="/"
            onClick={(e) => e.preventDefault()}
          >
            Handbags <KeyboardArrowDown />
            <ul className="dropdown-menu">
              {handbagsSubCats.map((sub) => (
                <li key={sub._id || sub.slug}>
                  <Link to={`/product-category/${sub.slug}`}>{sub.title}</Link>
                </li>
              ))}
            </ul>
          </Link>
          <Link
            className={
              isCategoryActive(footwearSubCats)
                ? "activeLink"
                : "nonActiveLink"
            }
            to="/"
            onClick={(e) => e.preventDefault()}
          >
            Footwear <KeyboardArrowDown />
            <ul className="dropdown-menu">
              {footwearSubCats.map((sub) => (
                <li key={sub._id || sub.slug}>
                  <Link to={`/product-category/${sub.slug}`}>{sub.title}</Link>
                </li>
              ))}
            </ul>
          </Link>
          <Link
            className={
              isCategoryActive(silverSubCats)
                ? "activeLink"
                : "nonActiveLink"
            }
            to="/"
            onClick={(e) => e.preventDefault()}
          >
            Silver Accessories <KeyboardArrowDown />
            <ul className="dropdown-menu">
              {silverSubCats.map((sub) => (
                <li key={sub._id || sub.slug}>
                  <Link to={`/product-category/${sub.slug}`}>{sub.title}</Link>
                </li>
              ))}
            </ul>
          </Link>
          {isLoggedIn && (
            <Link
              className={path === "/profile" ? "activeLink" : "nonActiveLink"}
              to={`/account/${userId}`}
            >
              Account
            </Link>
          )}
        </PageLinksDiv>
        <UserControlsDiv>
          {isLoggedIn && <Link to={`/account/${userId}/orders`}>Orders</Link>}
          {!isLoggedIn && <Link to="/login">Login</Link>}
          {!isLoggedIn && <Link to="/register">Register</Link>}
          {isLoggedIn && (
            <Link
              onClick={() => {
                dispatch({ type: "logout" });
                menuButtonHandler();
                navigate("/");
              }}
              to="/"
            >
              Log out
            </Link>
          )}
          <Link to="/wishlist">
            <Badge badgeContent={wishlistTotalItems} color="primary">
              <FavoriteBorderOutlined color="action" />
            </Badge>
          </Link>
          <Link to="/cart">
            <Badge badgeContent={cartTotalItems} color="primary">
              <LocalMallOutlined color="action" />
            </Badge>
          </Link>
        </UserControlsDiv>
      </PcNav>
      <MobileNav>
        <button onClick={menuButtonHandler}>
          <div></div>
          <div></div>
          <div></div>
        </button>

        <LogoDiv logo={Logo}></LogoDiv>

        <div>
          <Link to="/wishlist" style={{ marginRight: "12px" }}>
            <Badge badgeContent={wishlistTotalItems} color="primary">
              <FavoriteBorderOutlined color="action" />
            </Badge>
          </Link>
          <Link to="/cart">
            <Badge badgeContent={cartTotalItems} color="primary">
              <LocalMallOutlined color="action" />
            </Badge>
          </Link>
        </div>
      </MobileNav>
    </MainNav>
  );
};

export default Navbar;
